import React from 'react'
import AdvertisingBanner from '../../components/advertisingBanner/AdvertisingBanner'
import SimpleBanner from '../../components/simpleBanner/SimpleBanner'
import CheckItemSection from '../../components/checkItemSection/CheckItemSection'
import FooterLight from '../../components/footerLight/FooterLight'

const About = ({ isRtl, toggleLanguage }) => {

  const englishTexts = [
    "Integrated platform... multiple capabilities",
    "Farewell distractions... welcome peace of mind.",
    "Let us manage your staff to save you time and effort.",
    "Monitor workflow and manage employees from anywhere at anytime.",
  ];

  const arabicTexts = [
    "منصة متكاملة ... إمكانيات متعددة",
    "وداعا للتشتت ... أهلا براحة البال -",
    "دعنا نتولى إدارة موظفيك لتوفير وقتك وجهدك.",
    "راقب سير العمل وإدارة الموظفين من أي مكان وفي أي زمان ",
  ];

  return (
    <>
      <SimpleBanner isRtl={isRtl} />
      {/* <AdvertisingBanner
        heading={isRtl
          ? (
            <>
              وداعاً للتشتت ... أهلاً براحة البال <br />
              منصة متكاملة ... إمكانيات متعددة
            </>
          )
          : 'Advertising'
        }
        isRtl={isRtl} /> */}
      <AdvertisingBanner texts={isRtl ? arabicTexts : englishTexts} isRtl={isRtl} />
      <CheckItemSection isRtl={isRtl} />
      <FooterLight />
    </>
  )
}

export default About